import button from './button';
import colors from './colors';
import input from './input';
import modal from './modal';
import toast from './toast';

export default {
  input,
  button,
  modal,
  toast,

  colors,
};
